import { render } from "./IconNearMe.vue?vue&type=template&id=85aab488"
import script from "./IconNearMe.vue?vue&type=script&lang=js"
export * from "./IconNearMe.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__